import { PromiseQueue } from '@utils'

export const ecPaymentsQueue = new PromiseQueue()
